var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "color-sample-items" },
    [
      _vm.items.length > 0
        ? _vm._l(_vm.items, function (item, key) {
            return _c("color-sample-item", {
              key: key,
              attrs: {
                color: item.color,
                quantity: item.qty,
                "unit-price": item.unit_price,
                "can-modify-quantity": _vm.canModifyQuantity,
                "can-modify-structure": _vm.canModifyStructure,
                "set-structure": item.structure,
                "action-url": _vm.actionUrl,
                structures: _vm.structures,
                currency: _vm.currency,
              },
              on: { updateCartData: _vm.onUpdateCartData },
            })
          })
        : [
            _c("div", { staticClass: "color-sample-empty-cart" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.trans("sample_order_empty_cart_title"))),
              ]),
              _c("p", { staticClass: "bodytext" }, [
                _vm._v(_vm._s(_vm.trans("sample_order_empty_cart_text"))),
              ]),
              _c("a", { attrs: { href: _vm.getInspirationLink } }, [
                _vm._v(_vm._s(_vm.getInspirationLabel)),
              ]),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }